import { en, type MessageKey, type Messages } from "./messages/en";
import { vi } from "./messages/vi";

export const catalogs: Record<"en" | "vi", Messages> = {
  en,
  vi,
};

export type Locale = keyof typeof catalogs;

export const LOCALES: Locale[] = ["en", "vi"];

export function isLocale(value: unknown): value is Locale {
  return value === "en" || value === "vi";
}

export function resolveLocale(value: unknown): Locale {
  return isLocale(value) ? value : "en";
}

export function translate(
  locale: Locale,
  key: MessageKey,
  params?: Record<string, string | number>,
): string {
  let message: string = catalogs[locale][key] ?? catalogs.en[key] ?? key;
  if (params) {
    for (const [name, value] of Object.entries(params)) {
      message = message.replaceAll(`{${name}}`, String(value));
    }
  }
  return message;
}

export type { MessageKey };
